import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { DefaultService } from '../../utils/default.service';
import { MessageService } from 'primeng/api';
import { PrivilegeService } from '../../shared/privilege.service';
import { JobsService } from '../../admin/scheduler-config/jobs.service';

@Component({
  selector: 'app-monitor-data',
  templateUrl: './monitor-data.component.html',
  styleUrls: ['./monitor-data.component.scss']
})
export class MonitorDataComponent implements OnInit {
  classIDToFundSummaryMap: Map<string, any> = new Map<string, any>();
  classIDToHolidayCalcInfoMap: Map<string, any> = new Map<string, any>();
  fundList: any = [];
  fundIDToAggregatedNAV1HoldingsMap: Map<string, any> = new Map<string, any>();
  fundIDToAggregatedNAV2HoldingsMap: Map<string, any> = new Map<string, any>();
  fundIDToNAV1BondHoldingsStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV2BondHoldingsStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV1DerivativeHoldingsStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV2DerivativeHoldingsStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV1EquityHoldingsStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV2EquityHoldingsStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV1MoneyMarketHoldingsStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV2MoneyMarketHoldingsStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToRiskNAVStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV1DataArrayMap: Map<string, any[]> = new Map<string, any[]>();
  fundIDToNAV2DataArrayMap: Map<string, any[]> = new Map<string, any[]>();
  fundIDToNAV1SignedOffStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToNAV2SignedOffStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToPerformanceDataMap: Map<string, any[]> = new Map<string, any[]>();
  fundIDToRetreatFromPeakDataArrayMap: Map<string, any> = new Map<string, any>();
  fundIDToRetreatFromPeakDataStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToStoplossArrayMap: Map<string, any> = new Map<string, any>();
  fundIDToStoplossStatusMap: Map<string, boolean> = new Map<string, boolean>();
  fundIDToSuspendedStocksArrayMap: Map<string, any[]> = new Map<string, any[]>();
  indexIDToIndexPriceDataMap: Map<string, any> = new Map<string, any>();

  @Input() asOfDate: any;

  canPickTheDatePriv = { 'screenName': 'ProfileBar', 'subModule': 'canPickTheDate' };
  currentDate: any;
  disabledDatesArr: (void | Date)[];
  highlight: boolean = true
  highlightDate: any;
  loading = true;
  loadingPerformance = true;
  loadingNAV = true;
  maxDate: any;
  month: any;
  ngCalendar: boolean = false

  constructor(
    private datePipe: DatePipe,
    private defaultService: DefaultService,
    private jobsService: JobsService,
    private messageService: MessageService,
    public privilegeService: PrivilegeService
  ) { }

  // Initialize the directive (ngOnInit) or component after Angular first displays the data-bound properties and
  // sets the directive or component's input properties. ngOnInit is called once, after the first ngOnChanges().
  // ngOnInit() is called even when ngOnChanges() is not (which is the case when there are no template-bound changes.)
  ngOnInit(): void {
    this.currentDate = localStorage.getItem('asOfDate') ? new Date(localStorage.getItem('asOfDate')) : new Date();
    this.asOfDate = this.currentDate;
    this.setMaxDate();
    this.getAllFundsNAV1Data(this.datePipe.transform(this.asOfDate, 'yyyy-MM-dd'));
    this.getAllFundsNAV2Data(this.datePipe.transform(this.asOfDate, 'yyyy-MM-dd'));
    this.getListOfFundsWithStatusActive(this.datePipe.transform(this.asOfDate, 'yyyy-MM-dd'));
    this.getListOfIndexPrices(this.datePipe.transform(this.asOfDate, 'yyyy-MM-dd'));
    this.getRiskFundSummaryList(this.datePipe.transform(this.asOfDate, 'yyyy-MM-dd'));
    this.getSuspendedStockList(this.datePipe.transform(this.asOfDate, 'yyyy-MM-dd'));
  }

  areDatesEqual(date1: any, date2: any) {
    // Check validity of input dates
    if (isNaN(Date.parse(date1)) || isNaN(Date.parse(date2))) {
      return false;
    }
    if (this.datePipe.transform(date1, 'yyyy-MM-dd') === this.datePipe.transform(date2, 'yyyy-MM-dd')) {
      return true;
    }
    return false;
  }

  getAllFundsNAV1Data(asOfDate: string) {
		const url = 'cop/cdb/recon/dashboard/NAV1/' + asOfDate;
		const query = { queryParams: { 'trade_date': { 'equals': asOfDate }, 'is_latest': { 'equals': true }, 'recon_type': { 'equals': 'NAV1' } } };
		this.defaultService.get(query, 1, 1000, url).then(
      response => {
			if (response && response.status === 'success') {
				let fundNAV1DataList = [...response.data?.rows];
        fundNAV1DataList.forEach(fundNAV1Data => {
          if (fundNAV1Data.sign_off_status === 'SIGNED-OFF') {
            this.fundIDToNAV1SignedOffStatusMap.set(fundNAV1Data.fund_id, true);
          } else {
            this.fundIDToNAV1SignedOffStatusMap.set(fundNAV1Data.fund_id, false);
          }
          if (this.fundIDToNAV1DataArrayMap.get(fundNAV1Data.fund_id)) {
            this.fundIDToNAV1DataArrayMap.get(fundNAV1Data.fund_id).push(fundNAV1Data);
          } else {
            let fundNAV1DataArray = [];
            fundNAV1DataArray.push(fundNAV1Data);
            this.fundIDToNAV1DataArrayMap.set(fundNAV1Data.fund_id, fundNAV1DataArray);
          }
        })
        this.loadingNAV = false;
        this.ngCalendar = true;
        return;
			}
      this.messageService.add({ severity: 'error', detail: response['status'] });
		}).catch((err: any) => {
			this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
		});
	}

  getAllFundsNAV2Data(asOfDate: string) {
		const url = 'cop/cdb/recon/dashboard/NAV2/' + asOfDate;
		const query = { queryParams: { 'trade_date': { 'equals': asOfDate }, 'is_latest': { 'equals': true }, 'recon_type': { 'equals': 'NAV2' } } };
		this.defaultService.get(query, 1, 1000, url).then(
      response => {
			if (response && response.status === 'success') {
				let fundNAV2DataList = [...response.data?.rows];
        fundNAV2DataList.forEach(fundNAV2Data => {
          if (fundNAV2Data.sign_off_status === 'SIGNED-OFF') {
            this.fundIDToNAV2SignedOffStatusMap.set(fundNAV2Data.fund_id, true);
          } else {
            this.fundIDToNAV2SignedOffStatusMap.set(fundNAV2Data.fund_id, false);
          }
          if (this.fundIDToNAV2DataArrayMap.get(fundNAV2Data.fund_id)) {
            this.fundIDToNAV2DataArrayMap.get(fundNAV2Data.fund_id).push(fundNAV2Data);
          } else {
            let fundNAV2DataArray = [];
            fundNAV2DataArray.push(fundNAV2Data);
            this.fundIDToNAV2DataArrayMap.set(fundNAV2Data.fund_id, fundNAV2DataArray);
          }
        })
        this.loadingNAV = false;
        this.ngCalendar = true;
        return;
			}
      this.messageService.add({ severity: 'error', detail: response['status'] });
		}).catch((err: any) => {
			this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
		});
	}

  getCalculatePerformanceAndTDTEConditionInfo(fundID: string, asOfDate: string) {
		this.defaultService.find({}, 1, 1000, 'risk/holiday/calc/monthwise/info/' + asOfDate + '/' + fundID).then(
      (response: any) => {
        if (response) {
          this.ngCalendar = true
          response.data.forEach(
            (holidayCalcInfo: { as_of_date: string | number | Date; acct_book_class_id: string; }) => {
              const date = new Date(holidayCalcInfo.as_of_date)
              if (this.datePipe.transform(date, 'yyyy-MM-dd') === this.datePipe.transform(this.asOfDate, 'yyyy-MM-dd')) {
                this.classIDToHolidayCalcInfoMap.set(holidayCalcInfo.acct_book_class_id, holidayCalcInfo);
              }
          })
          this.loadingNAV = false;
          this.ngCalendar = true;
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      (err: any) => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
	}

  getFundPerformanceData(fundID: string, asOfDate: string) {
		const url = 'risk/fundsummary/' + fundID + '/' + asOfDate;
		this.defaultService.find({}, 1, 1000, url).then(
      response => {
        if (response && response['status'] === 'success') {
          const fundAndIndexPerformanceData = response['data'];
          fundAndIndexPerformanceData.forEach((performanceData: { fund_id: string; }) => {
            if (this.fundIDToPerformanceDataMap.get(performanceData.fund_id)) {
              this.fundIDToPerformanceDataMap.get(performanceData.fund_id).push(performanceData);
            } else {
              let fundPerformanceDataArray = [];
              fundPerformanceDataArray.push(performanceData);
              this.fundIDToPerformanceDataMap.set(performanceData.fund_id, fundPerformanceDataArray);
            }
          });
          this.loadingPerformance = false;
          this.ngCalendar = true;
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
	}

  getRiskFundSummaryList(asOfDate: string) {
		asOfDate = asOfDate + 'T00:00:00.000Z';
    let query = {};
		query['asOfDate'] = asOfDate;
		query['active'] = 'Y';
		this.defaultService.riskfind(query, 0, 1000, 'fundsummary').then(
      response  => {
        if (response['status'] && response['status'] === 'success') {
          if (response['summaries']) {
            const fundSummaries = response['summaries'];
            fundSummaries.forEach(fundSummary => {
              this.classIDToFundSummaryMap.set(fundSummary.classID, fundSummary);
              this.fundIDToRiskNAVStatusMap.set(fundSummary.fundID, true);
              if (fundSummary.netAssetValue == 0) {
                this.fundIDToRiskNAVStatusMap.set(fundSummary.fundID, false);
              }
            });
            this.loading = false;
            this.ngCalendar = true;
            return;
          }
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
			  this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
		  }
    );
	}

  getNAV1HoldingsData(fundID: string, asOfDate: string) {
    const url = 'risk/fund/' + fundID + '/holdings';
    const query = { asOfDate: asOfDate, holdingType: 'NAV1' };
    this.defaultService.find(query, 1, 1000, url).then(
      response => {
        if (response) {
          let aggregatedViewData = response['aggrViewData'];
          this.fundIDToNAV1BondHoldingsStatusMap.set(fundID, true);
          this.fundIDToNAV1DerivativeHoldingsStatusMap.set(fundID, true);
          this.fundIDToNAV1EquityHoldingsStatusMap.set(fundID, true);
          this.fundIDToNAV1MoneyMarketHoldingsStatusMap.set(fundID, true);
          if (!response['aggrViewData']['bondHoldings']) {
            aggregatedViewData.bondHoldings = [];
          } else {
            let bondHoldings = response['aggrViewData']['bondHoldings'];
            if (bondHoldings.length > 0) {
              bondHoldings.forEach(bondHolding => {
                if (!bondHolding.sector) {
                  this.fundIDToNAV1BondHoldingsStatusMap.set(fundID, false);
                }
              });
            }
          }
          if (!response['aggrViewData']['derivativeHoldings']) {
            aggregatedViewData.derivativeHoldings = [];
          } else {
            let derivativeHoldings = response['aggrViewData']['derivativeHoldings'];
            if (derivativeHoldings.length > 0) {
              derivativeHoldings.forEach(derivativeHolding => {
                if (!derivativeHolding.sector) {
                  this.fundIDToNAV1DerivativeHoldingsStatusMap.set(fundID, false);
                }
              });
            }
          }
          if (!response['aggrViewData']['equityHoldings']) {
            aggregatedViewData.equityHoldings = [];
          } else {
            let equityHoldings = response['aggrViewData']['equityHoldings'];
            if (equityHoldings.length > 0) {
              equityHoldings.forEach(equityHolding => {
                if (!equityHolding.sector) {
                  this.fundIDToNAV1EquityHoldingsStatusMap.set(fundID, false);
                }
              });
            }
          }
          if (!response['aggrViewData']['moneyMarketHoldings']) {
            aggregatedViewData.moneyMarketHoldings = [];
          } else {
            let moneyMarketHoldings = response['aggrViewData']['moneyMarketHoldings'];
            if (moneyMarketHoldings.length > 0) {
              moneyMarketHoldings.forEach(moneyMarketHolding => {
                if (!moneyMarketHolding.sector) {
                  this.fundIDToNAV1MoneyMarketHoldingsStatusMap.set(fundID, false);
                }
              });
            }
          }
          this.fundIDToAggregatedNAV1HoldingsMap.set(fundID, aggregatedViewData);
          this.loading = false;
          this.ngCalendar = true;
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    )
  }

  getNAV2HoldingsData(fundID: string, asOfDate: string) {
    const url = 'risk/fund/' + fundID + '/holdings';
    const query = { asOfDate: asOfDate, holdingType: 'NAV2' };
    this.defaultService.find(query, 1, 1000, url).then(
      response => {
        if (response) {
          let aggregatedViewData = response['aggrViewData'];
          this.fundIDToNAV2BondHoldingsStatusMap.set(fundID, true);
          this.fundIDToNAV2DerivativeHoldingsStatusMap.set(fundID, true);
          this.fundIDToNAV2EquityHoldingsStatusMap.set(fundID, true);
          this.fundIDToNAV2MoneyMarketHoldingsStatusMap.set(fundID, true);
          if (!response['aggrViewData']['bondHoldings']) {
            aggregatedViewData.bondHoldings = [];
          } else {
            let bondHoldings = response['aggrViewData']['bondHoldings'];
            if (bondHoldings.length > 0) {
              bondHoldings.forEach(bondHolding => {
                if (!bondHolding.sector) {
                  this.fundIDToNAV2BondHoldingsStatusMap.set(fundID, false);
                }
              });
            }
          }
          if (!response['aggrViewData']['derivativeHoldings']) {
            aggregatedViewData.derivativeHoldings = [];
          } else {
            let derivativeHoldings = response['aggrViewData']['derivativeHoldings'];
            if (derivativeHoldings.length > 0) {
              derivativeHoldings.forEach(derivativeHolding => {
                if (!derivativeHolding.sector) {
                  this.fundIDToNAV2DerivativeHoldingsStatusMap.set(fundID, false);
                }
              });
            }
          }
          if (!response['aggrViewData']['equityHoldings']) {
            aggregatedViewData.equityHoldings = [];
          } else {
            let equityHoldings = response['aggrViewData']['equityHoldings'];
            if (equityHoldings.length > 0) {
              equityHoldings.forEach(equityHolding => {
                if (!equityHolding.sector) {
                  this.fundIDToNAV2EquityHoldingsStatusMap.set(fundID, false);
                }
              });
            }
          }
          if (!response['aggrViewData']['moneyMarketHoldings']) {
            aggregatedViewData.moneyMarketHoldings = [];
          } else {
            let moneyMarketHoldings = response['aggrViewData']['moneyMarketHoldings'];
            if (moneyMarketHoldings.length > 0) {
              moneyMarketHoldings.forEach(moneyMarketHolding => {
                if (!moneyMarketHolding.sector) {
                  this.fundIDToNAV2MoneyMarketHoldingsStatusMap.set(fundID, false);
                }
              });
            }
          }
          this.fundIDToAggregatedNAV2HoldingsMap.set(fundID, aggregatedViewData);
          this.loading = false;
          this.ngCalendar = true;
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    )
  }

  // Get a list of all Funds whose status is "active"
  getListOfFundsWithStatusActive(asOfDate: string) {
    const url = 'mrd/common/instruments';
    this.defaultService.find({}, 1, 1000, url).then(
      response => {
        if (response) {
          let retrievedFunds = response['data'];
          this.fundList = retrievedFunds.filter((fund: { active: string; }) => fund.active == "YES");
          this.fundList.forEach(fund => {
            if (fund.fundID) {
              this.getNAV1HoldingsData(fund.fundID, asOfDate);
              this.getNAV2HoldingsData(fund.fundID, asOfDate);
              this.getFundPerformanceData(fund.fundID, asOfDate);
              this.getRetreatFromPeakData(fund.fundID, asOfDate);
              this.getStoplossData(fund.fundID, asOfDate);
              this.getCalculatePerformanceAndTDTEConditionInfo(fund.fundID, asOfDate);
            }
          });
          this.loading = false;
          this.ngCalendar = true;
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    )
  }

  // Get a list of all Funds whose status is "active"
  getListOfIndexPrices(asOfDate: string) {
    const url = 'mrd/common/prices/' + asOfDate;
    this.defaultService.find({}, 1, 1000, url).then(
      response => {
        if (response) {
          let retrievedIndexPrice = response['data'];
          retrievedIndexPrice.forEach(indexPrice => {
            indexPrice["from_date"] = this.datePipe.transform(new Date(indexPrice["from_date"]), 'yyyy-MM-dd');
            this.indexIDToIndexPriceDataMap.set(indexPrice['from_instrument_id'], indexPrice);
          });
          this.loading = false;
          this.ngCalendar = true;
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    )
  }

  getStoplossData(fundID: string, asOfDate: string) {
		const url = 'stoploss/' + fundID + '/' + asOfDate;
    this.fundIDToStoplossStatusMap.set(fundID, false);
		this.defaultService.riskfind({}, 1, 1000, url).then(
      response => {
        if (response && response['status'] === 'success') {
          this.fundIDToStoplossArrayMap.set(fundID, response);
          if (response['bondHoldings'].length !== 0 && response['equityHoldings'].length !== 0) {
            this.fundIDToStoplossStatusMap.set(fundID, true);
          }
          this.loading = false;
          this.ngCalendar = true;
          return;
        }
      }
    ).catch(
      err => {
			  this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
		  }
    );
	}

  getRetreatFromPeakData(fundID: string, asOfDate: string) {
		const url = 'retreatFromPeak/' + fundID + '/' + asOfDate;
    this.fundIDToRetreatFromPeakDataStatusMap.set(fundID, false);
		this.defaultService.riskfind({}, 1, 1000, url).then(
      response => {
        if (response && response['status'] === 'success') {
          this.fundIDToRetreatFromPeakDataArrayMap.set(fundID, response);
          this.fundIDToRetreatFromPeakDataStatusMap.set(fundID, true);
          this.loading = false;
          this.ngCalendar = true;
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
			  this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
		  }
    );
	}

  getSuspendedStockList(asOfDate: string) {
		const query = {};
		query['asOfDate'] = asOfDate + 'T00:00:00.000Z';
		this.defaultService.riskfind(query, 1, 1000, 'firmsuspstock').then(
      response => {
        this.loading = false;
        if (response['status'] === 'success') {
          const suspendedStocksArray = response['data'];
          suspendedStocksArray.forEach((suspendedStock: { fundID: string; }) => {
            if (this.fundIDToSuspendedStocksArrayMap.get(suspendedStock.fundID)) {
              this.fundIDToSuspendedStocksArrayMap.get(suspendedStock.fundID).push(suspendedStock);
            } else {
              let suspendedStocksArray = [];
              suspendedStocksArray.push(suspendedStock);
              this.fundIDToSuspendedStocksArrayMap.set(suspendedStock.fundID, suspendedStocksArray);
            }
          });
          this.loading = false;
          this.ngCalendar = true;
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
			  this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
		  }
    );
	}

  onSelectDate(date: any) {
    this.loading = true;
    this.loadingPerformance = true;
    this.loadingNAV = true;
    this.ngCalendar = false;
    this.asOfDate = date;
    this.classIDToFundSummaryMap.clear();
    this.classIDToHolidayCalcInfoMap.clear();
    this.fundIDToAggregatedNAV1HoldingsMap.clear();
    this.fundIDToAggregatedNAV2HoldingsMap.clear();
    this.fundIDToNAV1BondHoldingsStatusMap.clear();
    this.fundIDToNAV2BondHoldingsStatusMap.clear();
    this.fundIDToNAV1DerivativeHoldingsStatusMap.clear();
    this.fundIDToNAV2DerivativeHoldingsStatusMap.clear();
    this.fundIDToNAV1EquityHoldingsStatusMap.clear();
    this.fundIDToNAV2EquityHoldingsStatusMap.clear();
    this.fundIDToNAV1MoneyMarketHoldingsStatusMap.clear();
    this.fundIDToNAV2MoneyMarketHoldingsStatusMap.clear();
    this.fundIDToNAV1DataArrayMap.clear();
    this.fundIDToNAV2DataArrayMap.clear();
    this.fundIDToNAV1SignedOffStatusMap.clear();
    this.fundIDToNAV2SignedOffStatusMap.clear();
    this.fundIDToPerformanceDataMap.clear();
    this.fundIDToRetreatFromPeakDataArrayMap.clear();
    this.fundIDToRetreatFromPeakDataStatusMap.clear();
    this.fundIDToRiskNAVStatusMap.clear();
    this.fundIDToSuspendedStocksArrayMap.clear();
    this.fundIDToStoplossArrayMap.clear();
    this.fundIDToStoplossStatusMap.clear();
    this.indexIDToIndexPriceDataMap.clear();
    localStorage.setItem('opsAsOfDate', this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd'));
		localStorage.setItem('asOfDate', this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd'));
    this.getAllFundsNAV1Data(this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd'));
    this.getAllFundsNAV2Data(this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd'));
		this.getListOfFundsWithStatusActive(this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd'));
    this.getListOfIndexPrices(this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd'));
    this.getRiskFundSummaryList(this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd'));
    this.getSuspendedStockList(this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd'));
  }

  runRiskGetNAV1HoldingsFromOPSJob(fundID: string, slaType: string, event: any) {
    event.target.disabled = true;
    const url = "triggerJob";
    const paramObj = {};
    if (slaType == 'T0') {
      paramObj['asOfDate'] = this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    } else {
      let tomorrow = new Date(this.asOfDate);
      tomorrow.setDate(tomorrow.getDate() + 1);
      paramObj['asOfDate'] = this.datePipe.transform(new Date(tomorrow), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    }
    paramObj['fundIDs'] = [fundID];
    paramObj['jobType'] = 'RISK_GET_NAV1_HOLDINGS_INFO_FROM_OPSDB';
    paramObj['slaType'] = slaType;
    const formData = {};
    formData['jobReference'] = paramObj['jobType'];
    formData['params'] = paramObj;
    formData['reRun'] = 'true';

    this.jobsService.create(formData, url).then(
      response => {
        if (response['status'] === 'success') {
          this.messageService.add({ severity: 'success', detail: formData['jobReference'] + ' triggered successfully!' });
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
  }

  runRiskGetNAV2HoldingsFromOPSJob(fundID: string, slaType: string, event: any) {
    event.target.disabled = true;
    const url = "triggerJob";
    const paramObj = {};
    if (slaType == 'T0') {
      paramObj['asOfDate'] = this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    } else {
      let tomorrow = new Date(this.asOfDate);
      tomorrow.setDate(tomorrow.getDate() + 1);
      paramObj['asOfDate'] = this.datePipe.transform(new Date(tomorrow), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    }
    paramObj['fundIDs'] = [fundID];
    paramObj['jobType'] = 'RISK_GET_NAV2_HOLDINGS_INFO_FROM_OPSDB';
    paramObj['slaType'] = slaType;
    const formData = {};
    formData['jobReference'] = paramObj['jobType'];
    formData['params'] = paramObj;
    formData['reRun'] = 'true';

    this.jobsService.create(formData, url).then(
      response => {
        if (response['status'] === 'success') {
          this.messageService.add({ severity: 'success', detail: formData['jobReference'] + ' triggered successfully!' });
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
  }

  runRiskGetPerformanceTDTEJob(fundID: string, slaType: string, event: any) {
    event.target.disabled = true;
    const url = "triggerJob";
    const paramObj = {};
    if (slaType == 'T0') {
      paramObj['asOfDate'] = this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
      paramObj['jobType'] = 'RISK_T0_EOD_PERF_TDTE_GROUP';
    } else {
      let tomorrow = new Date(this.asOfDate);
      tomorrow.setDate(tomorrow.getDate() + 1);
      paramObj['asOfDate'] = this.datePipe.transform(new Date(tomorrow), 'yyyy-MM-dd') + 'T00:00:00.000Z';
      paramObj['jobType'] = 'RISK_T1_EOD_PERF_TDTE_GROUP';
    }
    paramObj['fundIDs'] = [fundID];
    paramObj['slaType'] = slaType;
    const formData = {};
    formData['jobReference'] = paramObj['jobType'];
    formData['params'] = paramObj;
    formData['reRun'] = 'true';

    this.jobsService.create(formData, url).then(
      response => {
        if (response['status'] === 'success') {
          this.messageService.add({ severity: 'success', detail: formData['jobReference'] + ' triggered successfully!' });
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
  }

  runRiskGetNAVFromOPSJob(fundID: string, slaType: string, event: any) {
    event.target.disabled = true;
    const url = "triggerJob";
    const paramObj = {};
    if (slaType == 'T0') {
      paramObj['asOfDate'] = this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    } else {
      let tomorrow = new Date(this.asOfDate);
      tomorrow.setDate(tomorrow.getDate() + 1);
      paramObj['asOfDate'] = this.datePipe.transform(new Date(tomorrow), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    }
    paramObj['fundIDs'] = [fundID];
    paramObj['jobType'] = 'RISK_GET_NAV_INFO_FROM_OPSDB';
    paramObj['slaType'] = slaType;
    const formData = {};
    formData['jobReference'] = paramObj['jobType'];
    formData['params'] = paramObj;
    formData['reRun'] = 'true';

    this.jobsService.create(formData, url).then(
      response => {
        if (response['status'] === 'success') {
          this.messageService.add({ severity: 'success', detail: formData['jobReference'] + ' triggered successfully!' });
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
  }

  runRiskEODHoldingsGroupJob(fundID: string, slaType: string, event: any) {
    event.target.disabled = true;
    const url = "triggerJob";
    const paramObj = {};
    if (slaType == 'T0') {
      paramObj['asOfDate'] = this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
      paramObj['jobType'] = 'RISK_T0_EOD_HOLDINGS_GROUP';
    } else {
      let tomorrow = new Date(this.asOfDate);
      tomorrow.setDate(tomorrow.getDate() + 1);
      paramObj['asOfDate'] = this.datePipe.transform(new Date(tomorrow), 'yyyy-MM-dd') + 'T00:00:00.000Z';
      paramObj['jobType'] = 'RISK_T1_EOD_HOLDINGS_GROUP';
    }
    paramObj['fundIDs'] = [fundID];
    paramObj['slaType'] = slaType;
    const formData = {};
    formData['jobReference'] = paramObj['jobType'];
    formData['params'] = paramObj;
    formData['reRun'] = 'true';

    this.jobsService.create(formData, url).then(
      response => {
        if (response['status'] === 'success') {
          this.messageService.add({ severity: 'success', detail: formData['jobReference'] + ' triggered successfully!' });
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
  }

  runRiskRetreatFromPeakJob(fundID: string, slaType: string, event: any) {
    event.target.disabled = true;
    const url = "triggerJob";
    const paramObj = {};
    if (slaType == 'T0') {
      paramObj['asOfDate'] = this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    } else {
      let tomorrow = new Date(this.asOfDate);
      tomorrow.setDate(tomorrow.getDate() + 1);
      paramObj['asOfDate'] = this.datePipe.transform(new Date(tomorrow), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    }
    paramObj['fundIDs'] = [fundID];
    paramObj['jobType'] = 'RISK_RETREAT_FROM_PEAK';
    paramObj['slaType'] = slaType;
    const formData = {};
    formData['jobReference'] = paramObj['jobType'];
    formData['params'] = paramObj;
    formData['reRun'] = 'true';

    this.jobsService.create(formData, url).then(
      response => {
        if (response['status'] === 'success') {
          this.messageService.add({ severity: 'success', detail: formData['jobReference'] + ' triggered successfully!' });
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
  }

  runRiskStopLossJob(fundID: string, slaType: string, event: any) {
    event.target.disabled = true;
    const url = "triggerJob";
    const paramObj = {};
    if (slaType == 'T0') {
      paramObj['asOfDate'] = this.datePipe.transform(new Date(this.asOfDate), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    } else {
      let tomorrow = new Date(this.asOfDate);
      tomorrow.setDate(tomorrow.getDate() + 1);
      paramObj['asOfDate'] = this.datePipe.transform(new Date(tomorrow), 'yyyy-MM-dd') + 'T00:00:00.000Z';
    }
    paramObj['fundIDs'] = [fundID];
    paramObj['jobType'] = 'RISK_STOP_LOSS';
    paramObj['slaType'] = slaType;
    const formData = {};
    formData['jobReference'] = paramObj['jobType'];
    formData['params'] = paramObj;
    formData['reRun'] = 'true';

    this.jobsService.create(formData, url).then(
      response => {
        if (response['status'] === 'success') {
          this.messageService.add({ severity: 'success', detail: formData['jobReference'] + ' triggered successfully!' });
          return;
        }
        this.messageService.add({ severity: 'error', detail: response['status'] });
      }
    ).catch(
      err => {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
    );
  }

  setMaxDate() {
		let maxDate: any;
		const date = this.defaultService.getStartOfTheDay(new Date());
		let noOfBizDays = 0;
		let day = date.getDay();
		maxDate = new Date(date.getTime() - (1 * 24 * 60 * 60 * 1000));
		day = maxDate.getDay();
		if (day !== 0 && day !== 6) {
			noOfBizDays += 1;
		}
		day = maxDate.getDay();
		while (noOfBizDays < 1) {
			maxDate = new Date(maxDate.getTime() - (1 * 24 * 60 * 60 * 1000));
			day = maxDate.getDay();
			if (day !== 0 && day !== 6) {
				noOfBizDays += noOfBizDays + 1;
			}
		}
		this.maxDate = maxDate;
	}
}